import BaseModule from './base-module';

// 物流线路
class Service extends BaseModule {
  // 物流线路列表
  serviceList(params) {
    return this.post('/admin/i_lis/serviceList', params);
  }

  // 线路价格详情
  getServicePrice(params) {
    return this.post('/admin/i_lis/getServicePrice', params);
  }

  // 设置线路价格
  setServicePrice(params) {
    return this.post('/admin/i_lis/setServicePrice', params);
  }

  // 获取线路列表
  getServiceList(params) {
    return this.post('/admin/i_lis/getSerciveList', params);
  }
  // 编辑线路信息
  setService(params) {
    return this.post('/admin/i_lis/upLineService', params);
  }
  // 获取物品列表
  serviceGoodsList(params) {
    return this.post('/admin/i_lis/goodsList', params);
  }

  //添加/编辑物品
  addGoods(params) {
    return this.post('/admin/i_lis/addGoods', params);
  }

  //删除物品
  delGoods(params) {
    return this.post('/admin/i_lis/delGoods', params);
  }
}

export default new Service();
